<template>
  <footer class="app-footer">
    <RouterLink to="/legal/tos">Terms</RouterLink>
    <span aria-hidden="true">·</span>
    <RouterLink to="/legal/privacy">Privacy</RouterLink>
    <span aria-hidden="true">·</span>
    <RouterLink to="/legal/cookies">Cookies</RouterLink>
    <span aria-hidden="true">·</span>
    <RouterLink to="/status">Status</RouterLink>
  </footer>
</template>

<style scoped>
.app-footer {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 0.75rem;
  justify-content: center;
  padding: 2rem 1rem 2.5rem;
  font-size: 0.875rem;
  color: var(--color-muted);
}
.app-footer a {
  color: inherit;
  text-decoration: none;
}
.app-footer a:hover {
  color: var(--color-primary);
  text-decoration: underline;
}
</style>